import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";

export function LoginPage() {
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleLogin() {
    setLoading(true);
    setError("");
    try {
      await login();
    } catch (e) {
      setError(e instanceof Error ? e.message : "Login failed");
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
      background: "var(--color-base)",
    }}>
      <div style={{ textAlign: "center", maxWidth: 320, width: "100%" }}>
        <h1 style={{ fontSize: 28, color: "var(--color-accent)", marginBottom: 8 }}>TillFlo</h1>
        <p style={{ color: "var(--color-muted)", marginBottom: 40, fontSize: 14 }}>Admin Dashboard</p>

        <button
          className="btn-primary"
          style={{ width: "100%", fontSize: 15 }}
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Signing in…" : "Sign in with Internet Identity"}
        </button>

        {error && (
          <p style={{ color: "var(--color-red)", fontSize: 13, marginTop: 16 }}>{error}</p>
        )}
      </div>
    </div>
  );
}
